import i18next from 'i18next';
import React from 'react';

import PreviousCurrentCell from '../../common/PreviousCurrentCell';

export const globalColumns = (enableTicketsNumber) => {
  const defaultColumns = [
    {
      field: 'storeName',
      headerName: i18next.t('GENERAL.STORE'),
      width: 200,
      sortable: true,
    },
    {
      field: 'turnoverExcludingTaxes',
      headerName: i18next.t('GENERAL.TURNOVER_EX_TAX'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value.current}
          previous={params.value.previous}
          isClickable
          isCurrency
        />
      ),
    },

    {
      field: 'realFoodConsumption',
      headerName: i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_SHORT'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value.current}
          isIncreasePositive={false}
          previous={params.value.previous}
          isClickable
          isCurrency
        />
      ),
    },
    {
      field: 'realFoodConsumptionRatio',
      headerName: i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_RATIO_SHORT'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value.current}
          isIncreasePositive={false}
          previous={params.value.previous}
          isClickable
          isPercentage
        />
      ),
    },
  ];

  if (!enableTicketsNumber) {
    return defaultColumns;
  }

  return defaultColumns.concat([
    {
      field: 'tickets',
      headerName: i18next.t('ANALYSIS.PERFORMANCE.TICKETS'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value.current}
          previous={params.value.previous}
          isClickable
        />
      ),
    },
    {
      field: 'averageTicket',
      headerName: i18next.t('ANALYSIS.PERFORMANCE.AVERAGE_TICKET'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value.current}
          previous={params.value.previous}
          hasDecimals
          isClickable
          isCurrency
        />
      ),
    },
  ]);
};
